import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseManningVesselCategoryApi = AiseaApiFactory.get("enterpriseManningVesselCategory");
const cApi = AiseaApiFactory.get("constant");

export default {
  async fetchAllManningVesselCategories({ commit }) {
    let res = await enterpriseManningVesselCategoryApi.search();
    commit("SET_MANNING_VESSEL_CATEGORY_LIST", res.data.manning_vessel_categories);
  },

  async fetchAllCountryCodes({ commit }) {
    let resCountryCode = await cApi.fetchCountryCode();
    commit("SET_COUNTRY_CODE_LIST", resCountryCode.data.country_codes);
  },

};
